import axios from 'axios'
import {to} from './utils'

export default {
  async createUser (body) {
    return to(axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/v1.0/ureg `, body))
  },  
  async getToken (body) {
    const AuthStr = 'Basic '.concat(btoa(`${body.username}:${body.password}`));
    return to(axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/v1.0/token`, { headers: { Authorization: AuthStr } }))
  },
  async verifyPhoneNumber (body) {
    return to(axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/v1.0/uphoneact`, body))
  },
  async resetPassword (body) {
    return to(axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/v1.0/profile/reset`, body))
  },
  async resetPasswordSendCode (body) {
    return to(axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/v1.0/profile/reset_complete`, body))
  },
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/endpoints/auth.js
// module id = null
// module chunks = 